<template>
  <!-- サブメニュー -->
  <ul class="l-sidebar-list-sub">
    <li v-for="item in items" :key="item.title" class="l-sidebar-list-sub__item">
      <a v-if="item.target == '_blank'" :href="item.url" :target="item.target">{{ item.title }}</a>
      <a v-else :target="item.target" @click="onLinkClick(item.url)">{{ item.title }}</a>
    </li>
  </ul>
  <!-- /サブメニュー -->
</template>

<script>
export default {
  props: {
    items: Array,
    onLinkClick: Function,
  },
};
</script>
